@if (interestListChips()?.length > 0) {
  <section class="register-user__interests-field">
    <header class="interests-field__header">
      <h3 class="interests-field__title ci-heading-h2-s-bold">
        {{ 'Intereses' | translate }}
      </h3>

      @if(isInvalidField()) {
        <mat-error class="ci-paragraph-p1-regular">
          {{ 'Mínimo 3 intereses son obligatorios' | translate }}
        </mat-error>
      } @else { 
        <p class="ci-paragraph-p1-regular interests-field__helper-text">
          <span>{{ 'Selecciona mínimo 3 intereses' | translate }}
            <strong> ({{ 'obligatorio' | translate }})</strong>
          </span>
        </p>
      }
    </header>

    <main>
      <ci-chip-set 
        multiselect
        (change)="handleChipSetInterestsChange($event)"
      >
        @for(interest of interestListChips(); track interest.id) {
          <ci-filter-chip-outline
            class="register-user__interest-chip"
            [chip]="interest"
            [attr.icon-name]="interest?.iconName"
            [value]="interest.id"
            [attr.data-selected]="isSelectedInterest(interest.id)"
            [selected]="isSelectedInterest(interest.id)"
          >
            <span slot="label">
              {{ interest.label }}
            </span>
          </ci-filter-chip-outline>
        }
      </ci-chip-set>
    </main>
  </section>
}